import SectionHeading from "@/components/base/SectionHeading";
import { featuredTopics } from "@/mocks/spotlight";

export default function FeaturedTopics() {
  return (
    <section id="featured" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="Today's Focus"
            title="今日看点"
            desc="编辑团队从全站讨论中挑选出关注度最高、观点分歧最明显的话题，帮你先看最有讨论价值的那些。"
          />
          <a
            href="#square"
            className="mb-8 hidden shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:inline-flex"
          >
            查看全部话题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {featuredTopics.map((topic) => (
            <article
              key={topic.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={topic.image}
                  alt={`${topic.title} 话题配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 font-label text-xs font-medium text-background-50">
                  {topic.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="font-label text-xs text-accent-700">{topic.tag}</span>
                <h3 className="mt-2 font-heading text-lg font-semibold leading-snug text-foreground-950">
                  {topic.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{topic.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                  <div className="flex items-center gap-4 font-label text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500"></i>
                      {topic.heat}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-1-line"></i>
                      {topic.comments}
                    </span>
                  </div>
                  <a
                    href="#arena"
                    className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap font-label text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
                  >
                    进入讨论
                    <i className="ri-arrow-right-up-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <a
          href="#square"
          className="mt-8 inline-flex w-full cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-3 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:hidden"
        >
          查看全部话题
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}